import React from 'react'
import { Header } from '../components'
import { votingProcedures } from '../sampleData'

const Education = () => {
  
  return (
    <div className='h-screen mx-1 flex flex-col items-center text-dark'>
      <Header pageView='Education'/>

      <main className='grid gap-8 mt-8'>
        <h2
        className='font-bold text-lg'
        >Voting Procedures</h2>
        <ol
        className='grid gap-2 font-semibold'
        >
          {votingProcedures.map((d,i) => (
            <li 
            key={i}
            >
              {d}
            </li>
          ))}
        </ol>
      </main>

      <footer className='mt-[47vh] w-full flex items-center justify-between bg-purple text-white px-2 py-1'>
            <div>
              <p
              className='font-semibold text-lg'
              >News &<br/> Updates</p>
            </div>
            <div className='text-sm '>
              <p>Voting starts on 24th May 2023</p>
              <p>Voting ends on 29th May 2023</p>
            </div>
      </footer>
    </div>

  )
}

export default Education